import React, { FC } from 'react';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { AdminLayout } from './components/Admin';
import { useAuth0 } from '@auth0/auth0-react';
import {
	Login,
	UserManagementPage,
	UserWatchlistsPage,
	UserActivityPage,
	UserPageViewsPage,
	UserViewsPage,
	WatchlistCompaniesPage,
	PeriodsPage,
	DatasetsPage,
	DatasetPermissionsPage,
	SymbolsPage,
	TeamDetailPage,
	OrganizationDetailPage,
	AccountDetailPage,
	TasksPage,
} from './views';
import { checkUserIsAdmin } from './utils/auth';

function RequireAuthAdmin() {
	const { user, isAuthenticated, isLoading } = useAuth0();
	const location = useLocation();

	if (isLoading) {
		return null;
	}
	if (!isAuthenticated || !user) {
		const fullPath = location.pathname + location.search + location.hash;
		return <Navigate to="/login" state={{ from: { pathname: fullPath } }} replace />;
	}
	if (!checkUserIsAdmin(user)) {
		return <Navigate to="/login" replace />;
	}
	return <Outlet />;
}

export const AppRoutes: FC = () => {
	return (
		<Routes>
			<Route path="/login" element={<Login />} />
			<Route element={<RequireAuthAdmin />}>
				<Route element={<AdminLayout />}>
					<Route path="/" element={<Navigate to="/admin/users" replace />} />
					<Route path="/admin/users" element={<UserManagementPage />} />
					<Route path="/admin/users/:user_id" element={<UserActivityPage />} />
					<Route path="/admin/users/:user_id/dataset-permissions" element={<Navigate to=".." replace />} />
					<Route path="/admin/users/:user_id/activity" element={<Navigate to=".." replace />} />
					<Route path="/admin/users/:user_id/watchlists" element={<UserWatchlistsPage />} />
					<Route path="/admin/users/:user_id/page-views" element={<UserPageViewsPage />} />
					<Route path="/admin/users/:user_id/views" element={<UserViewsPage />} />
					<Route path="/admin/tasks" element={<TasksPage />} />
					<Route path="/admin/watchlists/:watchlist_id/companies" element={<WatchlistCompaniesPage />} />
					<Route path="/admin/teams/:team_id" element={<TeamDetailPage />} />
					<Route path="/admin/organizations/:organization_id" element={<OrganizationDetailPage />} />
					<Route path="/admin/accounts/:account_id" element={<AccountDetailPage />} />
					<Route path="/admin/periods" element={<PeriodsPage />} />
					<Route path="/admin/datasets" element={<DatasetsPage />} />
					<Route path="/admin/datasets/:dataset_id/permissions" element={<DatasetPermissionsPage />} />
					<Route path="/admin/symbols" element={<SymbolsPage />} />
				</Route>
			</Route>
		</Routes>
	);
};
